import { currencySigns } from "./currencies";

export const displayPrice = (price, discount, convertPrice, selectedCurrency) => {
    const discountedPrice = price - (price * discount / 100);
    const originalPrice = price;
    return discount ? (
        <>
            <span className="line-through">{selectedCurrency} {convertPrice(price)}</span>
            <span className="text-red-500 ml-2">{selectedCurrency} {convertPrice(discountedPrice)}</span>
        </>
    ) : (
        <span>{currencySigns[selectedCurrency]} {convertPrice(originalPrice)}</span>
    );
};